<template lang="pug">
portal(
  v-if="instruction"
  to="afterwrap"
)
  instructions-slide(
    v-model="isDialogOpen"
    v-bind="instruction"
  )
  v-btn.btn-slide-dialog.z-index-6(
    color="primary"
    @click="showDialog"
  ) Инструкция: {{ instruction.name }}
</template>

<script>
import InstructionsSlide from '@/components/dialogs/SlideDialog/index.vue';

const GUEST_INSTRUCTION = {
  name: 'Вход в систему',
  idInstruction: 69,
};

export default {
  name: 'TheInstructions',
  components: {
    InstructionsSlide,
  },
  props: {},
  data() {
    return {
      isDialogOpen: false,
    };
  },
  computed: {
    instruction() {
      if (!this.$user.isAuthenticated) {
        return GUEST_INSTRUCTION;
      }

      const { instruction } = this.$route.meta;
      if (!instruction) {
        return null;
      }

      const id = Number.isInteger(instruction.id) ? instruction.id : this.getInstructionId(instruction.id);
      if (!id) {
        return null;
      }

      return {
        ...instruction,
        idInstruction: id,
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    showDialog() {
      this.isDialogOpen = true;
    },
    getInstructionId(id) {
      if ('*' in id) {
        return id['*'];
      }

      const role = Object.keys(id).find((key) => this.$user.hasRoles([key]));

      return id[role];
    },
  },
};
</script>
